import {
  DrawerProps,
  Drawer,
  Col,
  Row,
  Tooltip,
  Progress,
  Button,
  Image,
  Descriptions,
} from "antd";
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";
import CancelButton from "../../../../components/Buttons/CancelButton";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks/hooks";
import { useState } from "react";
import CommonModal from "../../../../components/Modals/CommonModal";
import CareerCategories from "../../../../assets/images/CareerCategories.svg?react";
import CareerWheel from "./../components/careerWheel/CareerWheel";

import { fetchPdfAssessmentResult } from "../utils/slice";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { b64toBlob, SvgToBase64 } from "../../../../config/Global";
import { Link } from "react-router-dom";

interface ViewDrawerProps extends DrawerProps {
  titleName: string;
  open: boolean;
  close: () => void;
}

/**
 * Renders a drawer component for viewing Career Compass result details.
 *
 * @param {ViewDrawerProps} props - The props object containing the following properties:
 *   - titleName: The name of the assessment result.
 *   - open: A boolean indicating whether the drawer is open or not.
 *   - close: A function to close the drawer.
 *   - rest: Additional props.
 * @return {ReactElement} The rendered drawer component.
 */
const ViewAssessmentResultDrawer: React.FC<ViewDrawerProps> = ({
  titleName,
  open,
  close,
  ...rest
}) => {
  const details = useAppSelector((state) => state.user.assessmentResultDetails);
  const assessmentId = useAppSelector((state) => state.user.assessmentResultId);
  const dispatch = useAppDispatch();
  const [reportDetails, setReportDetails] = useState<boolean>(false);
  const [careerId, setCareerId] = useState<number>(0);
  const careerDetails = details?.result?.[careerId]?.careers_detail;
  const [isReportDownloading, setIsReportDownloading] = useState(false);

  const firstColumnDataBoolean = Boolean(
    careerDetails?.description ||
    careerDetails?.knowledge_skills ||
    careerDetails?.video_url ||
    careerDetails?.file
  );

  const requirementDataBoolean = Boolean(
    careerDetails?.education_training ||
    careerDetails?.experience ||
    careerDetails?.credentialing
  );

  const secondColumnBoolean = Boolean(
    requirementDataBoolean ||
    careerDetails?.position_reports_to ||
    careerDetails?.career_path_moves_from_this_role ||
    careerDetails?.career_category_text
  );

  const drawerClose = () => {
    close();
  };

  // for downloading pdf report file of career compass result of User : start
  function saveBlobAsTextFile(blob: any, fileName: any) {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }
  function base64ToBlob(base64String: any, contentType = "") {
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: contentType });
  }

  const pdfResultDownload = async () => {

    setIsReportDownloading(true);
    let svg: any = document.querySelectorAll('.graphImage svg');
    if (svg.length > 0) {
      svg = svg[0];
      let base64image = SvgToBase64(svg);
      const requestData = {
        image: base64image
      }
      // console.log('details',details)
      await dispatch(fetchPdfAssessmentResult(details.skill_id, requestData))
        .then((data: any) => {
          // const pdfData = base64ToBlob(data.data);

          // saveBlobAsTextFile(
          //   pdfData,
          //   `Career_Compass_Result_Report_${new Date()}.pdf`
          // );



          const file = b64toBlob(data.data, "application/pdf", 512);
          console.log(file);
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          console.log(fileURL);
          //Open the URL on new Window
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

          if (isSafari) {

            const link = document.createElement("a");
            link.href = fileURL;
            link.target = "_blank"; // This is ignored when 'download' is set

            link.download = "Result.pdf"; // Set filename here
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(fileURL); // Clean up
            window.open(fileURL, "_blank");

          } else {
            window.open(fileURL, "_blank");
          }

        })
        .catch((error: any) => error);
    }
    setIsReportDownloading(false);





  };
  // for downloading pdf report file of career compass result of User : end

  return (
    <Drawer
      title={`View ${titleName}`}
      open={open}
      placement="right"
      width={"80%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[<CancelButton key={2} onClick={drawerClose} />]}
      {...rest}
    >
      {details?.length !== 0 ? (
        <>
          {details?.exam_flag == undefined ?
            <Button
              type="primary"
              style={{ marginLeft: 0 }}
              onClick={pdfResultDownload}
            >
              {isReportDownloading && <LoadingOutlined />}
              <DownloadOutlined />
              Download Result Report{" "}
            </Button> :
            <h3>Default Result</h3>}
          <Row
            gutter={[5, 5]}
            style={{
              height: "100%",
              display: "flex",
              // alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Col sm={24} md={24} xl={8} xxl={8}>

              <CareerWheel resultData={details} />
              {/* <div className="graphImage">
                <CareerCategories />
              </div> */}
              {/* <div className="resultSeeDetails">
                <div className="subDetails">
                  <h3>
                    {" "}
                    Click on <span style={{ color: "green" }}>
                      See Details
                    </span>{" "}
                    under each career to learn more about personal career
                    matches in offshore wind!
                  </h3>{" "}
                </div>
              </div> */}
            </Col>
            <Col sm={24} md={24} xl={16} xxl={16}>
              <Row
                gutter={[15, 5]}
              // style={{ justifyContent: "center", gap: "1rem" }}
              >

                {
                  details?.result?.map((item: any, index: number) =>
                    <Col sm={24} md={24} lg={24} xl={12} key={index}>
                      <Link className='result-career' to={"#"} onClick={() => (
                        setReportDetails(true), setCareerId(index)
                      )}>
                        <div className='reportContentBox' style={{ width: '100%' }} >
                          <h3>{item.careers}</h3>

                          <h6>{item.careers_detail.category_name}</h6>
                          {/* <div dangerouslySetInnerHTML={{ __html: item.careers_detail.description }}></div> */}
                          {
                            item.careers_detail.description != null &&
                              item.careers_detail.description.startsWith('<p') ?
                              <div dangerouslySetInnerHTML={{ __html: item.careers_detail.description }}></div>
                              :
                              <div><p dangerouslySetInnerHTML={{ __html: item.careers_detail.description }}></p></div>
                          }
                          <div className='reportPrice' >${item.careers_detail.salary_start} - ${item.careers_detail.salary_end}</div>

                          <div className='interest-progess'>
                            <div className='interest-progess-title'>Interest</div>
                            <Tooltip title={`You scored ${Math.round(item?.interest_assessment_score)}% for Interest Discovery`} overlayClassName='examTooltip' trigger={'hover'}>
                              <Progress percent={Math.round(item?.interest_assessment_score)} strokeColor="#DFFBDF" showInfo={true} percentPosition={{ align: 'center', type: 'outer' }} />
                            </Tooltip>
                          </div>

                          <div className='skill-progess'>
                            <div className='skill-progess-title'>Skill</div>
                            <Tooltip title={`You scored ${Math.round(item?.skills_assessment_score)}% for Skill Portrait`} overlayClassName='examTooltip' trigger={'hover'}>
                              <Progress percent={Math.round(item?.skills_assessment_score)} strokeColor="#E1F5FB" showInfo={true} percentPosition={{ align: 'center', type: 'outer' }} />
                            </Tooltip>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  )
                }

                {/* {details &&
                  details?.result?.map((item: any, index: any) => {
                    return (
                      <Col
                        xxl={8}
                        xl={24}
                        md={24}
                        key={index}
                        className="reportContent"
                      >
                        <div className="categoryTitle">
                          <h3>{item.careers_detail.name}</h3>
                        </div>
                        <div className="reportName">
                          <p>{item.career_categories}</p>
                        </div>
                        <Tooltip
                          title={`User scored ${Math.round(
                            item?.interest_assessment_score
                          )}%  for Interest Discovery`}
                          overlayClassName="examTooltip"
                          trigger={"hover"}
                        >
                          <Progress
                            percent={Math.round(item?.interest_assessment_score)}
                            size={[250, 15]}
                            strokeColor="#1DAB3B"
                            showInfo={false}
                          />
                        </Tooltip>
                        <Tooltip
                          title={`User scored ${Math.round(
                            item?.skills_assessment_score
                          )}% for Skill Portrait`}
                          overlayClassName="examTooltip"
                          trigger={"hover"}
                        >
                          <Progress
                            percent={Math.round(item?.skills_assessment_score)}
                            size={[250, 15]}
                            strokeColor="#009CD1"
                            showInfo={false}
                          />
                        </Tooltip>
                        <div className="seeMoreDetails">
                          <span
                            
                          >
                            See Details
                          </span>
                        </div>
                      </Col>
                    );
                  })} 
                <div className="colorInformation">
                  <div className="colorInterest colorBox">
                    <span className="interestColorBox "></span>Interest
                    Discovery
                  </div>
                  <div className="colorSkill colorBox">
                    <span className="skillColorBox "></span>Skill Portrait
                  </div>
                </div>*/}
              </Row>
            </Col>
          </Row>
        </>
      ) : (
        <Descriptions
          column={1}
          bordered
          layout="horizontal"
          labelStyle={{ width: "18%" }}
        >
          <p>Career compass result data is not available </p>
        </Descriptions>
      )}

      {/* modal for view career details */}
      <CommonModal
        title={careerDetails?.name}
        open={reportDetails}
        onCancel={() => setReportDetails(false)}
        className="analystModal"
        width={firstColumnDataBoolean && secondColumnBoolean ? 1300 : 650}
      >
        <Row gutter={[30, 30]}>
          {firstColumnDataBoolean && (
            <Col sm={24} md={secondColumnBoolean ? 12 : 24}>
              <div>
                {careerDetails?.description && (
                  <div className="boxContent">
                    <div className="analystTitle">
                      <h4>DESCRIPTION</h4>
                    </div>
                    <div
                      className="cmsInnerContent"
                      dangerouslySetInnerHTML={{
                        __html: careerDetails?.description,
                      }}
                    ></div>
                  </div>
                )}
                {careerDetails?.knowledge_skills && (
                  <div className="boxContent">
                    <div className="analystTitle">
                      <h4>KNOWLEDGE/SKILLS</h4>
                    </div>
                    <div
                      className="cmsInnerContent"
                      dangerouslySetInnerHTML={{
                        __html: careerDetails?.knowledge_skills,
                      }}
                    ></div>
                  </div>
                )}
              </div>
              {careerDetails?.file && (
                <div className="careerResultImage">
                  <Image
                    alt="career image"
                    width={"100%"}
                    src={`${import.meta.env.VITE_REACT_APP_IMAGE_API_URL + careerDetails?.file
                      }`}
                  />
                </div>
              )}
              {careerDetails?.video_url && (
                <div className="careerResultVideo">
                  <iframe
                    width="100%"
                    height="350px"
                    src={`https://www.youtube.com/embed/${careerDetails?.video_url?.split("v=")[1]
                      }?autoplay=1&mute=1`}
                    title="YouTube Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </Col>
          )}
          {secondColumnBoolean && (
            <Col sm={24} md={firstColumnDataBoolean ? 12 : 24}>
              {requirementDataBoolean && (
                <div className="boxContent">
                  <div className="boxTitle">
                    <h4>REQUIREMENTS</h4>
                  </div>
                  <div className="boxInnerContent">
                    {careerDetails?.education_training && (
                      <div className="requirementSubHeader">
                        <h4>Education/Training</h4>
                        <div
                          className="innerBoxSubHeader"
                          dangerouslySetInnerHTML={{
                            __html: careerDetails?.education_training,
                          }}
                        ></div>
                      </div>
                    )}
                    {careerDetails?.experience && (
                      <div className="requirementSubHeader">
                        <h4>Experience</h4>
                        <div
                          className="innerBoxSubHeader"
                          dangerouslySetInnerHTML={{
                            __html: careerDetails?.experience,
                          }}
                        ></div>
                      </div>
                    )}
                    {careerDetails?.credentialing && (
                      <div className="requirementSubHeader">
                        <h4>Credentialing (Required/Optional)</h4>
                        <div
                          className="innerBoxSubHeader"
                          dangerouslySetInnerHTML={{
                            __html: careerDetails?.credentialing,
                          }}
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {careerDetails?.salary_start && careerDetails?.salary_end && (
                <div className="boxContent">
                  <div className="boxTitle">
                    <h4>SALARY RANGE</h4>
                  </div>
                  <div
                    className="boxInnerContent"
                  // dangerouslySetInnerHTML={{
                  //   __html: careerDetails?.position_reports_to,
                  // }}
                  >
                    <p>{`$${careerDetails.salary_start || '0.00'} - $${careerDetails.salary_end || '0.00'}`}</p>
                  </div>
                  {/* <p>123</p><p>2343</p> */}
                </div>
              )}
              {careerDetails?.career_path_moves_from_this_role && (
                <div className="boxContent">
                  <div className="boxTitle">
                    <h4>CAREER PATH MOVES FROM THIS ROLE</h4>
                  </div>
                  <div
                    className="boxInnerContent"
                    dangerouslySetInnerHTML={{
                      __html: careerDetails?.career_path_moves_from_this_role,
                    }}
                  ></div>
                </div>
              )}
              {careerDetails?.career_category_text && (
                <div className="boxContent">
                  <div className="boxTitle">
                    <h4>CAREER CATEGORIES</h4>
                  </div>
                  <div
                    className="boxInnerContent"
                    dangerouslySetInnerHTML={{
                      __html: careerDetails?.career_category_text,
                    }}
                  ></div>
                </div>
              )}
            </Col>
          )}
        </Row>
      </CommonModal>
    </Drawer>
  );
};

export default ViewAssessmentResultDrawer;
